import { BulletShape, BulletLegendOrientation } from './types.js';

const BulletLegendDefaultConfig = {
    items: [],
    labelClassName: '',
    onLegendItemClick: undefined,
    labelFontSize: null,
    labelMaxWidth: null,
    bulletSize: null,
    bulletShape: d => { var _a; return (_a = d.shape) !== null && _a !== void 0 ? _a : BulletShape.Circle; },
    orientation: BulletLegendOrientation.Horizontal,
    renderIntoProvidedDomNode: false,
};

export { BulletLegendDefaultConfig };
//# sourceMappingURL=config.js.map
